export const actionTypes = {
  GET_FILE_PENDING_APPROVALS: "GET_FILE_PENDING_APPROVALS",
  SET_FILE_PENDING_APPROVALS: "SET_FILE_PENDING_APPROVALS",
  APPROVE_OR_REJECT_FILES: "APPROVE_OR_REJECT_FILES",
  GET_FILTERED_APPROVALS: "GET_FILTERED_APPROVALS",
};

export const actions = {
  getFilesPendingApprovals: (payload) => ({
    type: actionTypes.GET_FILE_PENDING_APPROVALS,
    payload: payload,
  }),

  setFilesPendingApprovals: (payload) => ({
    type: actionTypes.SET_FILE_PENDING_APPROVALS,
    payload: payload,
  }),

  approveOrRejectFiles: (payload) => ({
    type: actionTypes.APPROVE_OR_REJECT_FILES,
    payload: payload,
  }),

  getFilteredApprovals: (payload) => ({
    type: actionTypes.GET_FILTERED_APPROVALS,
    payload: payload,
  }),
};
